module.exports = __webpack_public_path__ + "img/753d04d.jpg";